
<div class="slds-brand-band slds-brand-band_medium">
<div class="login_spinner">
  <ngl-spinner [size]="size" [variant]="variant" alternativeText="Loading"></ngl-spinner>
</div>
</div>
